import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Navbar } from "../../../components/Navbar/Navbar";
import { Footer } from "../../../components/Footer/Footer";
import { Banner } from "../../../components/Banner/Banner";
import titleImage from "../../../assets/images/galleryTitleLine.png";
import title2Image from "../../../assets/images/galleryTitleLine2.svg";
import "./GalleryDetail.css";

export const GalleryDetail = () => {
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';
    const { id } = useParams();
    const navigate = useNavigate();

    const [gallery, setGallery] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) setIsAdmin(true);

        const fetchGallery = async () => {
            try {
                const res = await fetch(`${BOARD_URL}/gallery/${id}`);
                if (!res.ok) throw new Error("게시물을 찾을 수 없습니다.");
                const data = await res.json();
                setGallery(data);
            } catch (err) {
                console.error(err);
                alert("존재하지 않는 게시물입니다.");
                navigate('/gallery');
            } finally {
                setLoading(false);
            }
        };

        fetchGallery();
    }, [id, BOARD_URL, navigate]);

    const handleDelete = async () => {
        if (!window.confirm("정말 이 사진을 삭제하시겠습니까?")) return;
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${BOARD_URL}/gallery/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                alert("삭제되었습니다.");
                navigate('/gallery');
            } else {
                alert("삭제에 실패했습니다.");
            }
        } catch (err) {
            console.error(err);
            alert("서버 오류가 발생했습니다.");
        }
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <Banner title="갤러리" />
                <div className="page" style={{textAlign:'center', padding:'100px'}}>로딩중...</div>
                <Footer />
            </>
        );
    }

    if (!gallery) return null;

    return (
        <>
            <Navbar />
            <Banner title="갤러리" />
            
            <div className="pageGallery">
                <div className="topGallery">
                    <div className="top-title">{gallery.title}</div>
                    
                    
                    <div className="top-content">
                        <div className="top-content-text">관리자</div>
                        <div className="top-content-text">
                            {new Date(gallery.createdAt).toLocaleDateString()}
                        </div>
                    </div>
                </div>

                {/* 관리자 버튼 위치 변경 (이미지 위, 오른쪽 정렬을 위한 컨테이너 추가) */}
                {isAdmin && (
                    <div className="admin-container">
                        <div className="adming">
                            <button 
                                className="ad-btn modify" 
                                onClick={() => navigate(`/gallery/GalleryEdit/${id}`)}
                            >
                                수정
                            </button>
                            <button 
                                className="ad-btn delete"
                                onClick={handleDelete}
                            >
                                삭제
                            </button>
                        </div>
                    </div>
                )}

                <div className="main-gallery-detail">
                    <div className="main-item">
                        {/* 인라인 스타일 제거, CSS로 제어 */}
                        <img 
                            src={gallery.imageUrl}
                            alt={gallery.title} 
                        />
                    </div> 
                    
                    {gallery.content && (
                        <div className="main-content">
                            {gallery.content}
                        </div>
                    )}
                </div>

                <div className="gallery-detail-btn-wrap">
                        <button className="gallery-list-btn" onClick={() => navigate('/gallery')}>
                            목록으로
                        </button>
                </div>

            </div>
            
            <Footer />
        </>
    );
};